import { Component, Input, OnInit } from '@angular/core';
import { WebService, lastValueFrom, NavTabService } from '@services';
import { RmsModule } from '@rms';
import { Inventory, Column, HeaderButton } from '@interfaces';

import { InventoryDataComponent } from './inventory-data/inventory-data.component';

@Component({
  selector: 'app-inventory',
  imports: [RmsModule, InventoryDataComponent],
  templateUrl: './inventory.component.html',
  styleUrl: './inventory.component.scss'
})
export class InventoryComponent implements OnInit {
  @Input() DashboardInventoryID?:number;
  InventoryList: Inventory[] = [];
  filteredInventoryList: Inventory[] = [];
  InventoryColumns: Column[] = [];
  SelectedInventory: Inventory | null = null;
  showFilterPanel = false;
  Buttons: HeaderButton[] = [
    {
      label: "Reports", menu: [
        { label: "Inventory Report By Warehouse", onAction: () => { console.log("Report 1") } },
        { label: "Supplier Report", onAction: () => { console.log("Report 2") } },
        { label: "Report Based On Current View", onAction: () => { console.log("Report 3") } },
      ]
    }
  ]

  constructor(private webService: WebService, private navTab: NavTabService) { }

  async ngOnInit(InventoryID?: any) {
    this.InventoryList = await this.GetInventoryList();
    this.filteredInventoryList = [...this.InventoryList];
    this.InventoryColumns = await this.CreateInventoryColumns();
    const serializedColumns = JSON.stringify(this.InventoryColumns)
    InventoryID = InventoryID ?? this.DashboardInventoryID;
    if (InventoryID) {
      const selectedInventory = this.InventoryList.find(item => item.InventoryID === InventoryID);
      if (selectedInventory) {
        this.openInventoryDetail(selectedInventory);
      }
    }
  }

  async GetInventoryList(): Promise<Inventory[]> {
    return await lastValueFrom(this.webService.getWebCall('inventory', 'coffee/inventory/inventory-data',));
  }

  async CreateInventoryColumns(): Promise<Column[]> {
    return [
      { key: 'InventoryID', label: 'Ref #', type: 'number', hidden: false, clickable: true, onActionKey: 'openInventoryDetail', onAction: (row) => this.openInventoryDetail(row) },
      { key: 'InventoryTypeName', label: 'Coffee / SKU', hidden: false },
      { key: 'BagsOrdered', label: 'Bags Purchased', type: 'number', hidden: true },
      { key: 'BagsInbounded', label: 'Bags Received', type: 'number', hidden: true },
      { key: 'AvailableQty', label: 'Bags Available', type: 'number', hidden: true },
      { key: 'PurchaseDate', label: 'Purchased', type: 'date', SearchType: 'date', hidden: true },
      { key: 'SupplierName', label: 'Supplier', hidden: true },
      { key: 'DateIn', label: 'Date In', type: 'date', SearchType: 'date', hidden: true },
      { key: 'PurchaseOrderID', label: 'PO #', type: 'number', hidden: false, clickable: true, onActionKey: 'openPurchaseOrder', onAction: (row) => { this.openPurchaseOrder(row) } },
      { key: 'NetWeight', label: 'Net Weight', type: 'number', hidden: true },
      { key: 'ETADate', label: 'ETA', hidden: true, type: 'date', edit: localStorage["department"] == 'Inbound' },
      { key: 'ETDDateLogistics', label: 'ETD', hidden: true, type: 'date', edit: localStorage["department"] == 'Inbound' },
      { key: 'AfloatDate', label: 'Afloat', hidden: true, type: 'date', edit: localStorage["department"] == 'Inbound' },
      { key: 'DrayageAppointmentDate', label: 'WTA', hidden: true, type: 'date', edit: localStorage["department"] == 'Inbound' },
      { key: 'FinalPosition', label: 'Position', hidden: false },
      { key: 'FinalWarehouse', label: 'Warehouse', hidden: false },
      { key: 'BillOfLadingNumber', label: 'BOL #', hidden: false },
      { key: 'Marks', label: 'Marks', hidden: false },
      { key: 'SupplierReffNumber', label: 'Supplier Ref #', hidden: false },
      { key: 'Vessel', label: 'Vessel', hidden: true },
      { key: 'ArrivingPortString', label: 'Arrival Port', hidden: true },
      { key: 'ArrivingTerminalString', label: 'Arrival Terminal', hidden: true },
      { key: 'PortOfOriginString', label: 'Port Of Origin', hidden: true },
      { key: 'DrayageCompanyString', label: 'Drayage Company', hidden: true },
      { key: 'PerferredSSL', label: 'Preferred SSL', hidden: true },
      { key: 'SupplierSaleNo', label: 'Supplier Inv. #', hidden: true },
      { key: 'ContainerNumber', label: 'Container #', hidden: true },
      { key: 'PSSApprovalDate', label: 'PSS Approved', hidden: true, type: 'date', SearchType: 'date' },
      { key: 'SampledAtWarehouseDate', label: 'Sampled At Warehouse', hidden: true, type: 'date', SearchType: 'date' },
      { key: 'ArrivalApprovalDate', label: 'Arrival Approved', hidden: true, type: 'date', SearchType: 'date' },
      { key: 'PSSReceivedDate', label: 'PSS Received', hidden: true, type: 'date', SearchType: 'date' },
      { key: 'SampleBeforeStripping', label: 'Sample Before Stripping', hidden: true, type: 'checkbox', SearchType: 'checkbox' },
      {
        key: 'ChildKind', label: 'Child Kind', hidden: true, SearchType: 'select',
        dropdownSearchOptions: [
          { label: 'Slack', value: 'Slack' },
          { label: '22lb Box', value: '22lb Box' },
          { label: 'Convert SKU', value: 'Convert SKU' },
          { label: 'Transfer', value: 'Transfer' }
        ]
      },
      {key: 'ChildInventory', label: 'Is Child', hidden: true, type: 'checkbox', SearchType: 'checkbox' }
    ];
  }

  toggleFilterPanel() {
    this.showFilterPanel = !this.showFilterPanel;
  }
  async getInventory(InventoryID: number): Promise<Inventory | null> {
    const result = await lastValueFrom(
      this.webService.getWebCall(
        'inventory',
        'coffee/inventory/inventory-data',
        {
          params: [
            { name: 'InventoryID', value: InventoryID }
          ]
        }
      )
    );

    return result?.[0] ?? null;
  }
  async refreshInventory(InventoryID: any) {

    // const freshInventory = await this.getInventory(InventoryID);

    // if (!freshInventory) {
    //   return;
    // }

    // const idx = this.InventoryList.findIndex(
    //   x => x.InventoryID === InventoryID
    // );

    // if (idx >= 0) {

    //   // Existing row
    //   this.InventoryList[idx] = freshInventory;

    // } else {

    //   // New child row
    //   this.InventoryList.unshift(freshInventory);

    // }

    // this.filteredInventoryList = [...this.InventoryList];
    await this.ngOnInit();
    
    this.SelectedInventory = this.InventoryList.find(item => item.InventoryID === InventoryID) ?? null;
  }
  applyFilters(filters: { [key: string]: any }) {
    this.filteredInventoryList = this.InventoryList.filter(item => {
      return Object.keys(filters).every(key => {
        const value = filters[key];
        if (!value) return true; // No filter applied
        if (value === 'hasData') return item[key] != null && item[key] !== '';
        if (value === 'noData') return item[key] == null || item[key] === '';
        return item[key]?.toString().toLowerCase().includes(value.toLowerCase());
      });
    });
  }

  openInventoryDetail(Inventory: Inventory) {
    console.log(Inventory)
    this.SelectedInventory = Inventory;
  }

  openPurchaseOrder(Inventory: Inventory) {
    const purchaseOrderID = Inventory.PurchaseOrderID ?? 0;
    const navItem = this.navTab.getNavItemFromTitle("Purchase Orders");
    if (navItem) {
      this.navTab.addTab({ title: navItem.title, icon: navItem.icon, componentKey: navItem.componentKey, data: { PurchaseOrderID: purchaseOrderID } });
      
    }
  }
}
